import React, { useRef, useState } from 'react';
import { MadadAgentCard } from '../entities';
import AgentSmartCard from 'components/madad/agent-card/AgentSmartCard';
import { CarouselItem } from './styled';
import { LocalWinnersCarousel } from './LocalWinnersCarousel';
import { useScreenBreakpoint } from 'consts/breakpoints';
import { useIntersectionObserver } from 'hooks/useIntersectionObserver';

interface AgentsCarouselProps {
  agents: MadadAgentCard[];
}

export const AgentsCarousel: React.FC<AgentsCarouselProps> = props => {
  const { agents } = props;
  const isMobile = useScreenBreakpoint() === 1;
  const [ sectionInView, setSectionInView ] = useState(false);
  const carouselSectionNode = useRef<HTMLDivElement>(null);

  useIntersectionObserver(([ entry ]) => {
    setSectionInView(entry.isIntersecting);
  }, [ carouselSectionNode ], { threshold: 0 });

  return (
    <LocalWinnersCarousel rootNode={carouselSectionNode}>
      {agents.map(agent => (
        <CarouselItem key={agent.id}>
          <AgentSmartCard
            {...agent}
            isRegistered
            enablePhoneShowing={isMobile}
            sectionInView={sectionInView}
            rootNode={carouselSectionNode}
          />
        </CarouselItem>
      ))}
    </LocalWinnersCarousel>
  );
};
